import { gql } from "@apollo/client";

const schema = {
  list: {
    name: "state",
    serviceName: "graphql",
    query: gql`
      query state(
        $ids: [String]
        $title: String
        $page: Int
        $limit: Int
        $orderBy_field: String
        $orderBy_direction: String
      ) {
        state(
          ids: $ids
          title: $title
          page: $page
          limit: $limit
          orderBy_field: $orderBy_field
          orderBy_direction: $orderBy_direction
        ) {
          data {
            id
            title
            media {
              id
              full_url
            }
          }
          total
          last_page
        }
      }
    `,
  },
  delete: {
    name: "deleteState",
    serviceName: "admin",
    query: gql`
      mutation deleteState($ids: [String]!) {
        deleteState(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
  assignment: {
    name: "state",
    serviceName: "grapghql",
    query: gql`
      query state($ids: [String]) {
        state(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
